import { useEffect, useState } from "react";
import * as api from "../../api";

const NIVEL = {
  libre:    { clase: "lib", texto: "○ Libre" },
  normal:   { clase: "nor", texto: "● Normal" },
  saturada: { clase: "sat", texto: "▲ Saturada" },
};
const h = n => `${String(Math.round(n * 10) / 10).replace(".", ",")} h`;

// «Equipo»: la carga ASIGNADA a cada persona (pasos de proyecto y encargos), contra el limite
// semanal de su jornada. Nunca mide el tiempo que cada persona apunta en su Cuaderno.
export default function EquipoTab() {
  const [personas, setPersonas] = useState(null);
  const [error, setError] = useState("");
  const [v, setV] = useState(0);
  const [q, setQ] = useState("");
  const [info, setInfo] = useState({ alcance: "equipo", puede_buscar: false });

  // Sin buscar, la carga de MI equipo; quien puede buscar (admin de TIC) pide a toda la plantilla con un respiro al teclear
  useEffect(() => {
    let vivo = true;
    const texto = info.puede_buscar ? q.trim() : "";
    const pedir = () => api.getCargaEquipo(texto)
      .then(d => {
        if (!vivo) return;
        setPersonas(Array.isArray(d?.personas) ? d.personas : []);
        setInfo({ alcance: d?.alcance === "busqueda" ? "busqueda" : "equipo", puede_buscar: !!d?.puede_buscar });
        setError("");
      })
      .catch(e => { if (vivo) setError(e?.message || "No se ha podido cargar la carga del equipo"); });
    // Sin texto se pide al instante; al teclear, con un respiro
    const t = texto ? setTimeout(pedir, 300) : null;
    if (!texto) pedir();
    return () => { vivo = false; clearTimeout(t); };
  }, [v, q, info.puede_buscar]);

  if (error) {
    return <div className="mt-vacio" role="alert"><b>{error}</b>
      <button type="button" className="btn mt-reintentar" onClick={() => setV(x => x + 1)}>Reintentar</button></div>;
  }
  if (!personas) return <p className="mt-estado-pag" role="status">Calculando la carga del equipo…</p>;
  const hay = personas.some(p => p.asignadas > 0);
  const buscador = info.puede_buscar && (
    <div className="mt-filtros">
      <label htmlFor="mt-eq-q" className="sr-only">Buscar en toda la plantilla</label>
      <input id="mt-eq-q" className="mt-inp" type="search" placeholder="Buscar persona o equipo…" value={q} onChange={e => setQ(e.target.value)} />
    </div>
  );
  if (info.alcance === "busqueda" && !personas.length) {
    return <div>{buscador}<p className="mt-sel-nota" role="status">Nadie coincide.</p></div>;
  }
  if ((!personas.length || !hay) && info.alcance !== "busqueda") {
    return (
      <div className="mt-vacio">
        <b>Tu equipo aún no tiene tareas asignadas</b>
        Cuando mandes una tarea o se asigne un paso de proyecto, verás aquí la carga de cada persona.
      </div>
    );
  }
  // Si todas las personas tienen el mismo origen del limite, se dice una vez abajo en vez de repetirlo en cada una
  const origenes = new Set(personas.map(p => p.limite_origen));
  const mezcla = origenes.size > 1;
  return (
    <div>
      {/* Arriba, no al final: lo primero que se lee es que esto no juzga a nadie */}
      <p className="mt-sel-nota">La carga cuenta solo lo asignado (pasos de proyecto y tareas enviadas). No mide el tiempo que cada persona apunta en su Cuaderno.</p>
      {buscador}
      {info.alcance === "busqueda" && <p className="mt-sel-nota" role="status">Resultados de toda la plantilla (hasta 30).</p>}
      {personas.map(p => {
        const n = NIVEL[p.nivel] || NIVEL.normal;
        const sobrecargada = p.nivel === "saturada";
        const pct = Math.min(100, p.limite_semana > 0 ? (p.horas_estimadas / p.limite_semana) * 100 : 0);
        return (
          <section key={p.user_id} className={"mt-carga" + (sobrecargada ? " sat" : "")} aria-label={`Carga de ${p.nombre}`}>
            <div className="mt-carga-c">
              <span className="mt-av" aria-hidden="true">{p.nombre.split(" ").map(x => x[0]).join("").slice(0, 2)}</span>
              <b>{p.nombre}</b>
              <span className={"mt-sem " + n.clase}>{n.texto}</span>
            </div>
            <div className="mt-barra" role="img" aria-label={`${h(p.horas_estimadas)} estimadas de ${h(p.limite_semana)} por semana`}>
              <i style={{ width: `${pct}%` }} />
            </div>
            <div className="mt-carga-d">
              <span>{h(p.horas_estimadas)} estimadas de {h(p.limite_semana)}/sem</span>
              <span>{p.asignadas} {p.asignadas === 1 ? "tarea" : "tareas"}</span>
              <span className={p.vencidas ? "venc" : ""}>{p.vencidas} {p.vencidas === 1 ? "vencida" : "vencidas"}</span>
              {p.horas_estimadas === 0 && p.asignadas > 0 && <span style={{ fontWeight: 700 }}>Sin horas estimadas</span>}
            </div>
            {mezcla && (
              <div className="mt-sel-nota">
                {p.limite_origen === "odoo" ? "Límite según su jornada de Odoo" : "Límite por defecto (sin calendario fiable en Odoo)"}
              </div>
            )}
          </section>
        );
      })}
      {!mezcla && personas.length > 0 && (
        <p className="mt-sel-nota">
          {personas[0].limite_origen === "odoo" ? "El límite de cada persona sale de su jornada de Odoo." : "Límite por defecto para todos (sin calendario fiable en Odoo)."}
        </p>
      )}
    </div>
  );
}
